import { Abstract, Modify } from '../commons/commons.types';
import { Pilot } from './pilot.types';

export enum DroneClearanceEnum {
  FULL_CLEARANCE = 'FULL_CLEARANCE',
  CLEARANCE_WITHIN_FLIGHTPLAN = 'CLEARANCE_WITHIN_FLIGHTPLAN',
  FULL_CLEARANCE_WITHIN_FLIGHTPLAN = 'FULL_CLEARANCE_WITHIN_FLIGHTPLAN',
  NO_CLEARANCE = 'NO_CLEARANCE',
}

export type StrategicDrone = {
  id: number;
  drone: {
    id: number;
    code: string;
  };
  site: string;
  name: string;
  weight: number | null;
  range: number | null;
  autonomy: number | null;
  strategicClearance: DroneClearanceEnum;
  safetyDistance: number;
  criticalDistance: number;
  organization: string;
} & Abstract;

export type Drone = {
  id: number;
  site: string;
  code: string;
  serialNumber: string;
  immatriculation: string | null;
  functionalName: string | null;
  manufacturer: string | null;
  model: string | null;
  adsbNumber: string | null;
  groundStationNumber: string | null;
  holodroneNumber: string | null;
  aeroscopeNumber: string | null;
  skyEyeAntennaNumber: string | null;
  pilots: Pilot[];
  strategicDrones: StrategicDrone[];
  strategicDrone: StrategicDrone | null;
} & Abstract;

export type NormalizedDrone = Modify<
  Drone,
  {
    pilots: string[];
    strategicDrones: string[];
    strategicDrone: string | null;
  }
>;

export type DroneClearance = {
  id: string;
  site: string;
  clearance: DroneClearanceEnum | null;
  expiration: string | null;
  droneCode: string | null;
};

export type PartialDrone = Modify<
  Partial<Drone>,
  {
    strategicDrone: Partial<StrategicDrone>;
  }
>;
